Monitoring.Views ||= {}
class Monitoring.Views.SentimentView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents/sentiment"]

  events:
    'toolbarItemClick div.sentiment-icon': 'moderateSentiment'

  render: ->
    @$el.html @template(@model)
    @$el.find('.sentiment-icon').addClass("sentiment-icon-#{@model.type()}")
    @_createToolbar()
    @

  initialize: ({model, centerToolbar}) ->
    super
    @model = model
    @leftOffset = if centerToolbar then 0 else -30

  moderateSentiment: (event, item) =>
    @moderateSentiments(parseInt($(item).data('value')))
    @trigger 'sentiment:changed', @model.sentiment()
    $(item).parent().parent().remove() # Removes toolbar element

  _createToolbar: () ->
    @$el.find('div.sentiment-icon').modifiedtoolbar
      content: @$el.find('#user-options')
      position: 'bottom'
      event: 'click'
      hideOnClick: true
      adjustment: 5
      appendTo: @$el.find('#sentiment-options-container')
      leftOffset: @leftOffset

  moderateSentiments: (value) ->
    @model.setSentiment(value)
    if !@model.isReviewMode()
      @saveOnServer()
    else
      @render()

  saveOnServer: ->
    $.ajax
      url: '/social_content/sentiment.json/'
      type: 'POST'
      data:
        moderations: [ @model.get('id') ],
        sentiment: @model.sentimentValue()
      complete: => @render()
      dataType: 'json'

  destroy: ->
    @model = undefined
    @remove()
    false
